import { render } from "./UserNoticeForm.vue?vue&type=template&id=a41e9ac8&scoped=true"
import script from "./UserNoticeForm.vue?vue&type=script&lang=js"
export * from "./UserNoticeForm.vue?vue&type=script&lang=js"

import "./UserNoticeForm.vue?vue&type=style&index=0&id=a41e9ac8&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a41e9ac8"]])

export default __exports__